module.exports = __webpack_public_path__ + "img/download-line.e18606a4.svg";